import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_accessorial_charge_template_usageService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { template_id: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, BillingRates?: { Id?: number, BillingContractLine?: { Id?: number, BillingContractId?: number, BillingContract?: { Name?: string } }, BillingForecastRecords?: { Id?: string }[], BillingRecords?: { BillingRateId?: number }[] }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { template_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, BillingRates?: { Id?: number, BillingContractLine?: { Id?: number, BillingContractId?: number, BillingContract?: { Name?: string } }, BillingForecastRecords?: { Id?: string }[], BillingRecords?: { BillingRateId?: number }[] }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { template_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, BillingRates?: { Id?: number, BillingContractLine?: { Id?: number, BillingContractId?: number, BillingContract?: { Name?: string } }, BillingForecastRecords?: { Id?: string }[], BillingRecords?: { BillingRateId?: number }[] }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      template_id: number    }) {
        if(isNil($inParams.template_id)) {
          return true; 
        }
      return false;
    }
}
